import { render, staticRenderFns } from "./acces-consultations.html?vue&type=template&id=c0f86c60&scoped=true&external"
import script from "./acces-consultations.js?vue&type=script&lang=js&external"
export * from "./acces-consultations.js?vue&type=script&lang=js&external"
import style0 from "./acces-consultations.scss?vue&type=style&index=0&id=c0f86c60&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f86c60",
  null
  
)

export default component.exports